<template>
  <div>
    <div class="form-group required">
      <label class="control-label">Option 1</label>
      <input type="text" id="option_1" name="option_1" v-validate="'required'"
             v-model="inputs.option_1" class="form-control"
             placeholder="Option 1">
      <div class="help text-danger" v-show="errors.has('option_1')">
        {{ errors.first("option_1") }}
      </div>
    </div>
    <div class="form-group required">
      <label class="control-label">Option 2</label>
      <input type="text" id="option_2" name="option_2" v-validate="'required'"
             v-model="inputs.option_2" class="form-control"
             placeholder="Option 2">
      <div class="help text-danger" v-show="errors.has('option_2')">
        {{ errors.first("option_2") }}
      </div>
    </div>
    <div class="form-group required">
      <label class="control-label">Option 3</label>
      <input type="text" id="option_3" name="option_3" v-validate="'required'"
             v-model="inputs.option_3" class="form-control"
             placeholder="Option 3">
      <div class="help text-danger" v-show="errors.has('option_3')">
        {{ errors.first("option_3") }}
      </div>
    </div>
    <div class="form-group">
      <label class="control-label">Option 4</label>
      <input type="text" id="option_4" name="option_4"
             v-model="inputs.option_4" class="form-control"
             placeholder="Option 4">
      <div class="help text-danger" v-show="errors.has('option_4')">
        {{ errors.first("option_4") }}
      </div>
    </div>
    <div class="form-group">
      <label class="control-label">Option 5</label>
      <input type="text" id="option_5" name="option_5"
             v-model="inputs.option_5" class="form-control"
             placeholder="Option 5">
      <div class="help text-danger" v-show="errors.has('option_5')">
        {{ errors.first("option_5") }}
      </div>
    </div>
    <div class="form-group required">
      <label class="control-label">Correct option</label>
      <br>
      <el-select v-model="inputs.correct_options" style="width: 100%;" v-validate="'required'"
                 name="correct_options" placeholder="Select correct options">
        <el-option
          v-for="option in options"
          :key="option.value"
          :label="option.label"
          :value="option.value">
        </el-option>
      </el-select>
      <div class="help text-danger" v-show="errors.has('correct_options')">
        {{ errors.first("correct_options") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MCQFields',
  props: {
    inputs: {
      type: Object,
      default: {},
    }
  },
  inject: ['$validator'],
  data: () => ({
    options: [
      {value: 'option_1', label: 'Option 1'},
      {value: 'option_2', label: 'Option 2'},
      {value: 'option_3', label: 'Option 3'},
      {value: 'option_4', label: 'Option 4'},
      {value: 'option_5', label: 'Option 5'},
    ]
  }),
}
</script>
